module.exports = __webpack_public_path__ + "img/filter-icon.30f7b2b6.svg";